const FONT = `@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;500;600;700;800&family=Barlow:wght@300;400;500;600&display=swap');`;

export default function Terms({ onBack }) {
  return (
    <div style={{ minHeight:"100vh", background:"#0a0e1a", color:"#f0f4ff", fontFamily:"'Barlow', sans-serif" }}>
      <style>{FONT}</style>

      {/* Header */}
      <div style={{ background:"#111827", borderBottom:"1px solid rgba(255,255,255,0.07)", padding:"14px 24px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:22, fontWeight:800, letterSpacing:"0.04em" }}>
          <span style={{ color:"#00e5a0" }}>SCRAPS</span>
        </div>
        <button onClick={onBack} style={{ padding:"6px 16px", background:"transparent", border:"1px solid rgba(255,255,255,0.1)", borderRadius:6, color:"#8a96b0", cursor:"pointer", fontSize:13 }}>← Back</button>
      </div>

      {/* Content */}
      <div style={{ maxWidth:680, margin:"0 auto", padding:"48px 24px" }}>
        <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:36, fontWeight:800, marginBottom:4 }}>Terms of Service</div>
        <div style={{ fontSize:13, color:"#8a96b0", marginBottom:40 }}>Last updated: {new Date().toLocaleDateString("en-US", { month:"long", day:"numeric", year:"numeric" })}</div>

        {[
          {
            title: "1. No real money",
            body: "Scraps is a free-to-play platform. All wagering on Scraps is conducted exclusively using virtual credits. These credits have no monetary value, cannot be exchanged for cash, prizes, or any real-world currency, and cannot be transferred between users or withdrawn in any form. No actual money is ever wagered, won, or lost on Scraps.",
          },
          {
            title: "2. Entertainment only",
            body: "Scraps is designed purely for entertainment purposes. It is a social competition platform that uses real sports odds data to simulate a betting experience among friends and colleagues. Scraps does not operate as a gambling service, sportsbook, or any form of licensed wagering platform.",
          },
          {
            title: "3. Age requirement",
            body: "You must be at least 18 years of age to create an account or participate in any league on Scraps. By creating an account you confirm that you meet this requirement. Scraps reserves the right to terminate any account found to belong to a user under 18.",
          },
          {
            title: "4. League conduct",
            body: "Leagues on Scraps are private and invitation-based. League admins are responsible for managing their league members and ensuring appropriate conduct within their league. Scraps reserves the right to suspend or terminate any league or account that violates these terms or is used in a manner inconsistent with the platform's purpose.",
          },
          {
            title: "5. Account responsibility",
            body: "You are responsible for maintaining the confidentiality of your account credentials. You agree not to share your password or allow others to access your account. Any activity that occurs under your account is your responsibility. If you believe your account has been compromised, contact us immediately.",
          },
          {
            title: "6. Odds data",
            body: "Scraps displays real-time sports odds data sourced from licensed third-party providers for informational and entertainment purposes only. This data is used solely to create a realistic simulation experience and does not constitute financial or betting advice.",
          },
          {
            title: "7. No liability",
            body: "Scraps is provided \"as is\" without warranties of any kind. We are not liable for any disputes between league members, errors in odds data, technical outages, or any other issues arising from use of the platform. Scraps is not responsible for any decisions made based on information displayed on the platform.",
          },
          {
            title: "8. Privacy",
            body: "We collect your name, email address, and activity data (bets placed, credits, league participation) solely to operate the platform. We do not sell your data to third parties. Your email is used only for account-related communications such as verification, password reset, and league notifications.",
          },
          {
            title: "9. Changes to terms",
            body: "We may update these terms from time to time. Continued use of Scraps after changes are posted constitutes your acceptance of the updated terms. We will make reasonable efforts to notify users of significant changes via email.",
          },
          {
            title: "10. Contact",
            body: "If you have any questions about these terms or about Scraps, please contact us at hello@playscraps.com.",
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom:32 }}>
            <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:18, fontWeight:700, color:"#f0f4ff", marginBottom:10 }}>{section.title}</div>
            <div style={{ fontSize:14, color:"#8a96b0", lineHeight:1.9 }}>{section.body}</div>
          </div>
        ))}

        <div style={{ marginTop:48, paddingTop:24, borderTop:"1px solid rgba(255,255,255,0.07)", fontSize:13, color:"#4a5568", lineHeight:1.8 }}>
          <strong style={{ color:"#8a96b0" }}>Scraps / playscraps.com</strong><br/>
          hello@playscraps.com<br/>
          Scraps is a free-to-play entertainment platform. No real money is involved.
        </div>
      </div>
    </div>
  );
}
